// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1qUVt","header":"PatientBlock_header__3yA9s","label":"PatientBlock_label__2RX2m","option":"PatientBlock_option__1RaTM"};